import { BackendFetch, DevTools, FormatSimple, LanguageStorage, T, Tolgee, TolgeeProvider, VueTolgee } from '@tolgee/vue'
import consola from 'consola'
import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app'
import { useAppMachine } from '~/composables/useAppMachine'

export default defineNuxtPlugin({
  name: 'tolgee',
  async setup(nuxt) {
    consola.log('🔵 Initializing tolgee ...')
    const {
      public: { tolgee: config },
    } = useRuntimeConfig()

    const { locale } = useAppMachine()

    const tolgee = Tolgee()
      .use(DevTools())
      .use(BackendFetch())
      .use(FormatSimple())
      .use(LanguageStorage())
      .init({
        apiKey: config.key,
        apiUrl: config.url,
        availableLanguages: config.languages,
        language: locale.value,
        defaultLanguage: locale.value,
        defaultNs: config.defaultNamespace,
        ns: config.namespaces,
        onTranslationMissing: (handler) => {
          consola.error('Missing translation key: ', handler.key)
          return `missing-key-or-value: ${handler.key}`
        },
      })
    await tolgee.run()
    nuxt.vueApp.use(VueTolgee, { tolgee })
    nuxt.vueApp.component('T', T).component('TolgeeProvider', TolgeeProvider)

    return {
      provide: {
        tolgee,
      },
    }
  },
})
